class _OptionSerializer {
    constructor() {
        this.separator = '|';
    }
    serialize(optionSerializeData) {
        let serialized = `${optionSerializeData.optionId}${this.separator}${optionSerializeData.optionRoute}`;
        if (isValidNumber(optionSerializeData.contractTradableId)) {
            serialized += `${this.separator}${optionSerializeData.contractTradableId}`;
        }
        return serialized;
    }
    deserialize(serialized) {
        const parts = serialized.split(this.separator);
        return new OptionSerializeData(parseInt(parts[0]), parseInt(parts[1]), parts.length > 2 ? parseInt(parts[2]) : undefined);
    }
    createOptionSerializeData(option) {
        if (isNullOrUndefined(option)) {
            return new OptionSerializeData(undefined, undefined, undefined);
        }
        const optionId = option.Id;
        const optionRoute = option.Route;
        const contractTradableId = option.ForwardBaseInstrument.isFuturesSymbol
            ? option.ForwardBaseInstrument.InstrumentTradableID
            : undefined;
        return new OptionSerializeData(optionId, optionRoute, contractTradableId);
    }
}
export class OptionSerializeData {
    constructor(optionId, optionRoute, contractTradableId) {
        this.optionId = optionId;
        this.optionRoute = optionRoute;
        this.contractTradableId = contractTradableId;
    }
    equals(optionSerializeData) {
        return (this.optionId === optionSerializeData.optionId &&
            this.optionRoute === optionSerializeData.optionRoute &&
            this.contractTradableId === optionSerializeData.contractTradableId);
    }
}
export const OptionSerializer = new _OptionSerializer();
